export const remToPx = (rem: number): number => {
  const htmlFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize,
  );
  return rem * htmlFontSize;
};

export const formatTs = (timestamp: number | string | Date): string => {
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}, ${hours}:${minutes}`;
};

export const formatSeconds = (s: number | undefined) => {
  if (typeof s === 'undefined') return '0:00';

  const hours = Math.floor(s / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = Math.floor(s % 60);

  if (hours > 0) {
    return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${
      seconds < 10 ? '0' : ''
    }${seconds}`;
  }

  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

export const extractMs = (d: number, separator: string = '.') =>
  JSON.stringify(d).split(separator)[1]?.slice(0, 3) || '000';

export const currentDatetime = () => {
  const d = new Date();
  const pad = (n: number, width = 2): string => String(n).padStart(width, '0');
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}, ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.` +
    `${pad(d.getMilliseconds(), 3)}`
  );
};

(() => {
  const original = {
    log: console.log,
    info: console.info,
    warn: console.warn,
    error: console.error,
  };

  (Object.keys(original) as Array<keyof typeof original>).forEach((level) => {
    console[level] = (...args: unknown[]): void => {
      original[level](`[${currentDatetime()}]`, ...args);
    };
  });
})();
